
// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = ['vuex_user', 'vuex_Authorization', 'vuex_cartList', 'vuex_sendcodeDialogVisible', 'vuex_inviteCode']

// 保存变量到本地存储中
const saveLifeData = function (key, value) {
  // 判断变量名是否在需要存储的数组中
  if (saveStateKeys.indexOf(key) != -1) {
    // 获取本地存储的lifeData对象，将变量添加到对象中
    let tmp = {}
    try {
      // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
      tmp = localStorage.getItem('lifeData') ? JSON.parse(localStorage.getItem('lifeData')) : {}
      tmp[key] = value
      // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
      localStorage.setItem('lifeData', JSON.stringify(tmp))
    } catch (e) { }
  }
}
export {
  saveStateKeys,
  saveLifeData
}


// WEBPACK FOOTER //
// ./src/util/lifeData.js